import { walletAddressTypeImage } from "@lib/helpers/ColorHelper";
import {
  currencySymbol,
  formatCurrency,
  getSeparators,
} from "@lib/helpers/StringHelper";
import { AllCurrencies } from "@lib/types/Billing";
import { Typography } from "antd";
import { StyledFlex } from "../Table/index.styled";
import { CurrencyEnum } from "@lib/types/Transaction";

type Props = {
  amount: number | string;
  bold?: boolean;
  currency?: AllCurrencies;
  showAllDigits?: boolean;
  maxDigits?: number;
  showCurrency?: AllCurrencies | boolean;
  showCurrencyImage?: boolean;
  showCurrencySymbol?: boolean;
  hideDigit?: boolean;
  align?: "left" | "right";
};
export default function CoinPriceTextFormat(props: Props) {
  const {
    currency = CurrencyEnum.USD,
    showAllDigits = false,
    maxDigits = 10,
    bold,
    showCurrencyImage,
    showCurrencySymbol,
    hideDigit,
    align = "right",
  } = props;

  let showCurrency = props.showCurrency;
  if (showCurrency === true) {
    showCurrency = currency;
  }

  const { decimalSeparator } = getSeparators();
  const amountValue =
    typeof props.amount === "number"
      ? props.amount
      : parseFloat(props.amount as string);
  const amount = showAllDigits
    ? amountValue.toString()
    : formatCurrency(amountValue, currency);

  const amountParts = amount.split(decimalSeparator);
  const amountWithoutGroupSeparator = amountParts[0] || "";
  const amountWithoutDecimalSeparator = amountParts[1];
  const image = walletAddressTypeImage(
    (currency ? currency : showCurrency) as any,
  );
  const symbol = currencySymbol(currency as any);

  if (isNaN(amountValue) || !Number.isFinite(amountValue)) return `-`;

  return (
    <StyledFlex
      style={{ gap: 5, justifyContent: align === "left" ? "start" : "end" }}
    >
      {showCurrencySymbol && !showCurrencyImage && !image && (
        <Typography.Text>{symbol}</Typography.Text>
      )}

      <Typography.Text>
        {bold ? (
          <b>{amountWithoutGroupSeparator}</b>
        ) : (
          amountWithoutGroupSeparator
        )}
        {!hideDigit && amountWithoutDecimalSeparator && (
          <>
            ,<small>{amountWithoutDecimalSeparator.slice(0, maxDigits)}</small>
          </>
        )}
      </Typography.Text>

      <Typography.Text>
        {showCurrency && <small>{showCurrency}</small>}
      </Typography.Text>

      {showCurrencyImage && (
        <>
          {image ? (
            <img src={image} style={{ maxHeight: "17px" }} />
          ) : (
            <>
              {symbol.length < 2 && <Typography.Text>{symbol}</Typography.Text>}
            </>
          )}
        </>
      )}
    </StyledFlex>
  );
}
